import { Chip } from '@huspy/briks-web';
import React from 'react';

const FilterButton = ({
  handleClick,
  children,
  isActive,
  dataTest,
}: {
  handleClick: () => void,
  children: React.ReactNode,
  isActive?: boolean,
  dataTest?: string
}) => (
  <Chip
    variant={ isActive ? 'neutral' : 'glassy' }
    size='sm'
    onClick={ handleClick }
    data-test={ dataTest }
    style={ { cursor: 'pointer' } }
    py='2'
    px='3'
    borderWidth='1px'
    borderStyle='solid'
    borderColor={ isActive ? 'border-primary' : 'border-secondary' }
  >
    {children}
  </Chip>
);

export default FilterButton;
